import type { Slot } from '../types/slot';
import slotsJson from './slots.json';

/**
 * De Top 30 wordt beheerd in data/slots.json.
 * Bewerk daar posities, RTP, teksten enz. — de volgorde op de site volgt altijd het veld "rank".
 */
export const slots: Slot[] = [...(slotsJson as Slot[])].sort((a, b) => a.rank - b.rank);
